import script from "./AppNavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavBar.vue?vue&type=script&setup=true&lang=ts"

import "./AppNavBar.vue?vue&type=style&index=0&id=3df8e0a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3df8e0a5"]])

export default __exports__